// @ts-nocheck
import AssignmentForm from "./assignmentForm";
//--------------------------------------------------------------------------------------------
export default function PotholingPreChecklist({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Do you have a clear understanding of what the project involves?", type: "radio", required: true},
        {title: "Is all of the necessary equipment present and in good working order?", type: "radio", required: true},
        {title: "Do you have all of the necessary traffic control devices?",  type: "radio", required: true},
        {title: "Are your USA tickets up to date and available?",  type: "radio", required: true},
        {title: "Has a safety tailgate meeting been completed?", type: "radio", required: true},
        {title: "Are any standby's required? If so, where and what time will you be meeting them?", type: "radio", onYes: "textarea", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <AssignmentForm
            noPDF
            items = {items}
            {...rest}
        />
    )    
}
